module.exports = __webpack_public_path__ + "static/media/17.aeb21c41.png";